import api from "api/config";

const normalizeProviderPayload = (payload = {}) => {
  const p = { ...(payload || {}) };
  // New canonical field: webhookEvents
  // Backward-compat: if UI still uses defaultWebhookEvents/availableWebhookEvents, map -> webhookEvents.
  if (p.webhookEvents === undefined) {
    const fallback = p.defaultWebhookEvents ?? p.availableWebhookEvents;
    if (fallback !== undefined) p.webhookEvents = fallback;
  }
  // Stop sending old fields from client.
  delete p.defaultWebhookEvents;
  delete p.availableWebhookEvents;
  return p;
};

/**
 * Create Integration Provider
 */
export const createIntegrationAPI = async (payload) => {
  const response = await api({
    method: "POST",
    url: "/api/v1/integrations/providers",
    data: normalizeProviderPayload(payload),
  });

  return response.data;
};

/**
 * Get All Integrations
 */
export const getIntegrationsAPI = async (hotelId = null) => {
  const response = await api({
    method: "GET",
    url: "/api/v1/integrations/providers",
    params: hotelId ? { hotelId } : {},
  });

  return response.data;
};

/**
 * Get Single Integration
 */
export const getIntegrationByIdAPI = async (id) => {
  const response = await api({
    method: "GET",
    url: `/api/v1/integrations/providers/${id}`,
  });

  return response.data;
};

/**
 * Update Integration
 */
export const updateIntegrationAPI = async ({ id, data }) => {
  const response = await api({
    method: "PUT",
    url: `/api/v1/integrations/providers/${id}`,
    data: normalizeProviderPayload(data),
  });

  return response.data;
};

/**
 * Delete / Disable Integration
 */
export const deleteIntegrationAPI = async (id) => {
  const response = await api({
    method: "DELETE",
    url: `/api/v1/integrations/providers/${id}`,
  });

  return response.data;
};

/**
 * Save / Activate integration
 */
export const saveIntegrationAPI = async ({ hotelId, data }) => {
  const response = await api({
    method: "POST",
    url: `/api/v1/hotelIntegration/${hotelId}/integration`,
    data,
  });

  return response.data;
};

/**
 * Test integration connection
 * - draft mode → send payload
 * - persisted mode → send {}
 */
export const testIntegrationAPI = async ({ hotelId, data }) => {
  const response = await api({
    method: "POST",
    url: `/api/v1/hotelIntegration/${hotelId}/integration/test`,
    data,
  });

  return response.data;
};

/**
 * GET Integration Details For Edit Screen
 */

export const getHotelIntegrationDetailsAPI = async ({ hotelId, providerKey }) => {
  const query = providerKey ? `?providerKey=${providerKey}` : "";

  const { data } = await api.get(`/api/v1/hotelIntegration/${hotelId}/integration/details${query}`);

  return data;
};
